{
  "dss": {
    "button": {
      "back": "Tilbake",
      "cancel": "Avbryt",
      "close": "Lukk",
      "confirmDelete": "Ja, slett",
      "continue": "Fortsett",
      "logout": "Logg ut",
      "passwordReset": "Tilbakestill passord",
      "save": "Lagre",
      "verify": "Bekreft"
    },
    "error": {
      "403": "Du har ikke tilgang til denne siden.",
      "404": "Denne siden finnes ikke.",
      "generic": "Det har oppstått en feil. Prøv igjen senere.",
      "invalidConfirmationLink": "Bekreftelseslenken er utløpt eller er ugyldig på annen måte.",
      "throttling": "For mange forsøk. Denne operasjonen er blokkert en stund.",
      "title": "Feil",
      "title403": "Tilgang nektet",
      "title404": "Ikke funnet"
    },
    "footer": {
      "imprint": "Ansvarlig utgiver ",
      "legalEntity": "Andreas Stihl AS, 3202 Sandefjord",
      "privacy": "Personvernerklæring",
      "terms": "Brukervilkår"
    },
    "label": {
      "CRMAccountNumber": "CRM Account Number",
      "contact": "Kontakt",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "FORNAVN",
      "help": "Hjelp",
      "language": "SPRÅK",
      "lastname": "ETTERNAVN",
      "male": "Mr.",
      "needHelp": "trenger hjelp?",
      "newPassword": "Nytt passord",
      "newPassword2": "Bekrefte nytt passord",
      "oldPassword": "Nåværende passord",
      "organization": "ORGANISASJON",
      "password": "PASSORD",
      "required": "required",
      "salutation": "HILSEN",
      "select": "Vennligst velg"
    },
    "link": {
      "contact": "https://support.stihl.com/nb-NO/websso-contact/",
      "faq": "https://support.stihl.com/nb-NO/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Bekreft registrering",
        "wait": "Vent til du fullfører kontobekreftelsen."
      },
      "otp": {
        "btnResend": "Send e-post med bekreftelseskode på nytt",
        "msg": {
          "invalidOTP": "Det angitte engangspassordet er ugyldig.",
          "resendFail": "Kunne ikke sende koden på nytt. Vennligst prøv igjen senere."
        },
        "spamDetail": "Sjekk innboksen og spam-mappen din for en e-post fra STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Fikk du ikke mail?",
        "subtitle": "For å fortsette må du bekrefte e-postadressen din.",
        "title": "Bekreft brukerkontoen din",
        "txtVerifyMail": "Vennligst skriv inn den nye bekreftelseskoden vi sendte til e-postadressen din {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Det er ingenting å oppdatere.",
          "updateError": "Kunne ikke oppdatere personopplysninger.",
          "updated": "Personopplysninger ble oppdatert.",
          "userLoadErr": "Feil ved innlasting av brukerdata. Prøv igjen senere."
        },
        "secOrganization": "ORGANISASJON",
        "secPersonal": "PERSONLIG",
        "secSettings": "FORETRUKKE INNSTILLINGER",
        "title": "PERSONLIG INFO"
      },
      "postPwSet": {
        "info": "Du kan nå bruke ditt nye passord.",
        "link_name": "Fortsett til selvbetjening",
        "link_url": "/user/ui/",
        "title": "Ditt passord har blitt endret"
      },
      "resetPW": {
        "title": "Tilbakestill passordet"
      },
      "security": {
        "2fa": {
          "availableMethods": "Tilgjengelige 2FA-metoder:",
          "info": "Tofaktorautentisering (2FA) er en sikkerhetsfunksjon som gir kontoen din et ekstra lag med beskyttelse. Den krever at du bruker to metoder for å logge inn, i stedet for bare brukernavn og passord.",
          "method": {
            "email": "E-post",
            "emailDesc": "Få engangskoder sendt til deg via e-post for å fullføre autentiseringsforespørsler.",
            "oath": {
              "add": {
                "button": "Registrer Authenticator-appen"
              }
            }
          }
        },
        "authenticator": "Authenticator-app",
        "infoFederatedAccount": "Denne kontoen administreres av organisasjonens identitetsleverandør, så passordet kan ikke endres her. For å endre passordet ditt, logg inn via organisasjonens påloggingsside eller kontakt IT-administratoren din.",
        "lastUse": "Sist brukt {0}.",
        "msg": {
          "invalidPassword": "Ugyldig gjeldende passord oppgitt.",
          "passwordAlreadyUsed": "Kan ikke bruke de siste 5 passordene på nytt.",
          "pwUpdateError": "Det oppsto en feil under forsøk på å endre passord.",
          "pwUpdated": "Passordet ble endret."
        },
        "noDevice": "Ikke konfigurert",
        "oathAdd": {
          "appInfo": "For å gjøre STIHL-innloggingsprosessen enklere, kan du bruke Authenticator-apper som {0}, {1}, {2} osv. for å generere engangspassord som brukes som en sekundær faktor under innloggingsprosessen.<br/>Hvis du har mistet eller glemt mobilenheten din, kan du fortsatt bruke 2FA-koden som sendes via e-post når som helst.<br/><br/>Følg instruksjonene nedenfor for å konfigurere autentiseringsenheten din.",
          "badCode": "Ugyldig kode, prøv på nytt.",
          "error": "Det oppsto en feil under forsøk på å registrere autentiseringsenheten.",
          "headScan": "1. Skann QR-koden med autentiseringsappen din",
          "headVerify": "2. Bekreft koden",
          "infoKey": "oppsettsnøkkel",
          "infoKeyTitle": "Din tofaktorhemmelighet",
          "infoScanBottom": "Kan ikke skanne? Du kan bruke {0} til å konfigurere autentiseringsenheten manuelt app.",
          "infoVerify": "Skriv inn koden som er generert av autentiseringsappen din.",
          "success": "Autentiseringsenheten din er registrert. Du kan nå bruke den til å logge på.",
          "title": "Registrer tofaktorautentiseringsenheten din"
        },
        "oathDelete": {
          "error": "Det oppsto en feil under forsøk på å slette autentiseringsenheten.",
          "success": "Autentiseringsenheten ble slettet."
        },
        "passkeys": {
          "about": {
            "info1": "Passnøkler er par av kryptografiske nøkler (en offentlig nøkkel og en privat nøkkel) som lagres av en autentiseringsenhet du kontrollerer. Autentiseringsenheten kan bevise at en bruker er til stede og er autorisert til å bruke passordet. Autentiseringsenheter bekrefter autorisasjon med en PIN-kode, passord, biometrisk kode eller enhetspassord, avhengig av autentiseringsenhetens muligheter og konfigurasjon. Autentiseringsenheter finnes i mange former, for eksempel en iPhone- eller Android-enhet, Windows Hello, en FIDO2-maskinvaresikkerhetsnøkkel eller en passordbehandler.",
            "info2": "Når du logger deg på STIHL med et passord, bruker autentiseringsenheten din offentlig nøkkelkryptografi for å bevise identiteten din til STIHL uten å sende passordet. Passord er bundet til et nettstedsdomene, som stihl-sso.com, og krever en sikker tilkobling, noe som betyr at nettleseren vil nekte å autentisere seg til et lignende phishing-nettsted. Disse egenskapene gjør passord svært phishing-resistente og mye vanskeligere å angripe enn SMS eller TOTP 2FA, som kan phishes.",
            "info3": "Skybaserte tilgangsnøkkeltjenester lar tilgangsnøkler synkroniseres på tvers av enheter (som Apple-enheter, Android-enheter eller passordbehandlere), slik at de kan brukes fra flere steder og blir mindre lett mistet. Når du har konfigurert en synkronisert tilgangsnøkkel på én enhet, er den tilgangsnøkkelen tilgjengelig for bruk på tvers av flere enheter som bruker den samme tjenesten. Hvis du for eksempel registrerer en tilgangsnøkkel med iCloud-kontoen din ved hjelp av MacBook-ens Touch ID, kan du deretter bruke den tilgangsnøkkelen med ansiktet, fingeravtrykket, PIN-koden eller enhetspassordet ditt om hverandre på tvers av flere enheter som er koblet til den samme iCloud-kontoen.",
            "title": "Om tilgangsnøkler"
          },
          "add": {
            "button": "Legg til ny tilgangsnøkkel",
            "error": "Det oppsto en feil under forsøk på å legge til den nye tilgangsnøkkelen.",
            "success": "En ny tilgangsnøkkel ble lagt til."
          },
          "delete": {
            "button": "Slett tilgangsnøkkel",
            "error": "Det oppsto en feil under forsøk på å slette denne tilgangsnøkkelen.",
            "success": "Tilgangsnøkkelen ble slettet."
          },
          "edit": {
            "error": "Det oppsto en feil under forsøk på å lagre passnøkkelnavnet.",
            "name": "Passnøkkelnavn",
            "success": "Passnøkkelnavnet ble oppdatert.",
            "title": "Gi passnøkkelen din et navn for å skille den fra andre passnøkler"
          },
          "info": "Passnøkkel er et enkelt og sikkert alternativ til passord, som validerer identiteten din ved hjelp av berøring, ansiktsgjenkjenning, et enhetspassord eller en PIN-kode.",
          "none": "Ingen passnøkkel konfigurert.",
          "reallyDelete": "Er du sikker på at du vil slette passnøkkelen?",
          "registeredPasskeys": "Dine registrerte passnøkler:",
          "title": "Passnøkler"
        },
        "reallyDeleteDevice": "Er du sikker på at du vil slette autentiseringsenheten?",
        "secMFA": "Tofaktorautentisering",
        "secPwdChange": "Endre passord",
        "title": "Sikkerhet"
      },
      "setPW": {
        "acceptTC": "Bekreft våre {terms} og les {privacy}.",
        "killSSO": "Ugyldiggjøre alle aktive økter",
        "msg": {
          "tokenExpired": "Passordkoblingen eller koden er utløpt. Vennligst følg lenken for å tilbakestille passordet ditt: {link}."
        },
        "privacy": "Retningslinjer for personvern",
        "terms": "Vilkår og betingelser",
        "title": "SKRIV INN NYTT PASSORD"
      }
    },
    "validations": {
      "hasDigit": "Må inneholde siffer",
      "hasLowercase": "Må inneholde små bokstav(er)",
      "hasSpecial": "Må inneholde spesialtegn(er): {chars}",
      "hasUppercase": "Må inneholde store bokstav(er)",
      "invalidCharacters": "Inneholder ulovlige tegn",
      "maxLength": "Maksimalt {max} tegn tillatt",
      "minLength": "Minimum {min} tegn kreves",
      "notSameAsEmail": "For lik e-postadressen",
      "onlyValidCharactersAllowed": "Bare bokstaver, tall og mellomrom er tillatt.",
      "required": "Nødvendig verdi",
      "sameAsPassword": "Passordet og bekreftelsen stemmer ikke overens",
      "tcAccepted": "Vær opmærksom på vores generelle forretningsvilkår og databeskyttelseserklæringen.",
      "validEmail": "Ugyldig epostadresse.",
      "validOTP": "Vennligst skriv inn verifikasjonskoden."
    }
  }
}
